<mat-button-toggle-group [value]="activeView" aria-label="View selection">
    <mat-button-toggle [value]="AllocationsViewModel.Insights" disabled (click)="changeView(AllocationsViewModel.Insights)"
        >Insights
    </mat-button-toggle>
    <mat-button-toggle [value]="AllocationsViewModel.Workbench" (click)="changeView(AllocationsViewModel.Workbench)"
        >Workbench
    </mat-button-toggle>
    <!-- Deactivated for BRD and DUNS -->
    <mat-button-toggle [value]="AllocationsViewModel.Settings" disabled (click)="changeView(AllocationsViewModel.Settings)"
        >Settings
    </mat-button-toggle>
    <mat-button-toggle [value]="AllocationsViewModel.Summaries" (click)="changeView(AllocationsViewModel.Summaries)"
        >Summaries
    </mat-button-toggle>
</mat-button-toggle-group>
